/** Alt text for hausverwalter.ai logo marks (PNG, SVG, inline lockups). */
export const BRAND_LOGO_ALT: string =
  "hausverwalter.ai — Hausverwaltung Software aus Deutschland";

/** Tooltip / title for logo images and links. */
export const BRAND_LOGO_TITLE: string =
  "hausverwalter.ai | Hausverwaltung Software mit KI-Agenten";

/** Home link aria-label for marketing nav and footers. */
export const BRAND_HOME_ARIA_LABEL: string =
  "hausverwalter.ai Startseite — Hausverwaltung Software";
